import styled from "@emotion/styled";
import { COLOR_DIVIDER, MOBILE_SCREEN } from "./theme";

interface DividerProps {
  color?: string;
}

const Divider = styled.div<DividerProps>`
  height: 1px;
  width: 100%;
  background-color: ${({ color }) => color ?? COLOR_DIVIDER};
  ${MOBILE_SCREEN} {
    margin: 10px 0;
  }
`;

export default Divider;
